import { Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-purple-100 text-gray-800 py-12 px-6 border-t border-purple-100">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {/* About Us */}
        <div>
          <h4 className="text-lg font-semibold text-gray-900 mb-3">About Us</h4>
          <p className="text-sm text-gray-600">
            DialVia helps you make affordable international calls straight from your browser.
            Built by telecom-savvy developers to keep you connected wherever you go.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold text-gray-900 mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm text-gray-700">
            <li><Link to="/call" className="hover:underline">Make a Call</Link></li>
            <li><Link to="/buy-credits" className="hover:underline">Buy Credits</Link></li>
            <li><Link to="/buy-credits#calculator" className="hover:underline">Rates</Link></li>
            <li><Link to="/faq" className="hover:underline">FAQ</Link></li>
            <li><Link to="/blog" className="hover:underline">Blog</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-lg font-semibold text-gray-900 mb-3">Contact</h4>
          <ul className="text-sm space-y-2 text-gray-700">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1 text-gray-500" />
              <span>London, United Kingdom</span>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-1 text-gray-500" />
              <a href="mailto:support@dialvia.com" className="hover:underline">support@dialvia.com</a>
            </li>
            <li>
              <Link to="/support" className="hover:underline">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <hr className="my-8 border-gray-300" />

      {/* Bottom Bar */}
      <div className="text-center text-sm text-gray-500 space-x-4">
        <span>© 2025 DialVia Ltd. All rights reserved.</span>
        <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
        <Link to="/terms" className="hover:underline">Terms & Conditions</Link>
      </div>
    </footer>
  );
}
